const ReportingIcon = () => (
  <svg
    width="19px"
    height="22px"
    viewBox="0 0 20 22"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style={{ verticalAlign: "middle" }}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        transform="translate(-838.000000, -34.000000)"
        fill="currentColor"
        fillRule="nonzero"
      >
        <g id="chart" transform="translate(838.000000, 34.000000)">
          <path
            d="M10,4 C9.44771525,4 9,4.44771525 9,5 L9,15 C9,15.5522847 9.44771525,16 10,16 C10.5522847,16 11,15.5522847 11,15 L11,5 C11,4.44771525 10.5522847,4 10,4 Z M5,10 C4.44771525,10 4,10.4477153 4,11 L4,15 C4,15.5522847 4.44771525,16 5,16 C5.55228475,16 6,15.5522847 6,15 L6,11 C6,10.4477153 5.55228475,10 5,10 Z M15,8 C14.4477153,8 14,8.44771525 14,9 L14,15 C14,15.5522847 14.4477153,16 15,16 C15.5522847,16 16,15.5522847 16,15 L16,9 C16,8.44771525 15.5522847,8 15,8 Z M17,0 L3,0 C1.34314575,0 0,1.34314575 0,3 L0,17 C0,18.6568542 1.34314575,20 3,20 L17,20 C18.6568542,20 20,18.6568542 20,17 L20,3 C20,1.34314575 18.6568542,0 17,0 Z M18,17 C18,17.5522847 17.5522847,18 17,18 L3,18 C2.44771525,18 2,17.5522847 2,17 L2,3 C2,2.44771525 2.44771525,2 3,2 L17,2 C17.5522847,2 18,2.44771525 18,3 L18,17 Z"
            id="Shape"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

export default ReportingIcon;
